import { render, staticRenderFns } from "./Turn.vue?vue&type=template&id=4e74c697&lang=pug&"
import script from "./Turn.vue?vue&type=script&lang=js&"
export * from "./Turn.vue?vue&type=script&lang=js&"
import style0 from "./Turn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e74c697')) {
      api.createRecord('4e74c697', component.options)
    } else {
      api.reload('4e74c697', component.options)
    }
    module.hot.accept("./Turn.vue?vue&type=template&id=4e74c697&lang=pug&", function () {
      api.rerender('4e74c697', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mobileFSFB/Turn.vue"
export default component.exports